// Angular imports
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

// cc-common imports
import { IconConstants } from 'cc-common';

// 3rd party imports
import { formatNumber } from 'devextreme/localization';

// Service imports
import { PrecisionService } from '../../../../_services/shared-services/precision.service';
import { ServerErrorService } from '../../../../_services/shared-services/server-error.service';
import { DepositDetailsService } from '../../_services/cash-management/deposit-details.service';
import { DetailPopupsService } from '../../_services/detail-popups.service';

// Constant imports
import { StringFormatConstants } from '../../../../_constants/string-format-constants';

// Model imports
import { DepositParametersDto } from '../../_models/cash-management/deposits/deposit-parameters-dto';
import { DepositDetailResultDto } from '../../_models/cash-management/deposits/deposit-detail-result-dto';
import { DepositItemResultDto } from '../../_models/cash-management/deposits/deposit-item-result-dto';

@Component({
    selector: 'app-deposit-details',
    templateUrl: './deposit-details.component.html',
    styleUrls: ['./deposit-details.component.scss']
})
export class DepositDetailsComponent implements OnInit {
    @Input() visible = false;
    @Input() depositParams: DepositParametersDto;
    @Output() onDepositClose = new EventEmitter<boolean>();

    currencyFormat: string;
    dateFormat: string;
    loadingVisible = false;

    popupTitle: string;
    bankAccount: string;
    depositDetails: DepositDetailResultDto;
    depositSourceItems: DepositItemResultDto[];

    iconCheck = IconConstants.CHECK;
    iconClose = IconConstants.CLOSE;

    constructor(
        private readonly precisionService: PrecisionService,
        private readonly serverErrorService: ServerErrorService,
        private readonly depositsService: DepositDetailsService,
        private readonly detailsPopupService: DetailPopupsService
    ) {
        this.currencyFormat = this.precisionService.getCurrencyFormat();
        this.dateFormat = StringFormatConstants.dateFormat;
    }

    ngOnInit() {
        if (!!this.depositParams) {
            this.popupTitle = `Deposit # ${this.depositParams.cmDepositId}`;
            this.getDepositView();
        }
    }

    onShown(e: any): void {
        e.component.repaint();
    }

    onHidden(): void {
        this.visible = false;
        this.onDepositClose.emit(false);
    }

    currencyFormatter(value: number): string {
        return formatNumber(value, this.currencyFormat);
    }

    onSourceItemClick(row: DepositItemResultDto): void {
        if (row.itemSourceType === 'CASH_RECEIPT') {
            this.detailsPopupService.updateSubjectCashReceiptDetail(
                this.depositParams.managementCompanyId,
                this.depositParams.communityId,
                row.itemId
            );
        } else if (row.itemSourceType === 'AR_PAYMENT') {
            this.detailsPopupService.updateSubjectARPaymentDetail(
                this.depositParams.managementCompanyId,
                this.depositParams.communityId,
                row.itemId
            );
        }
    }

    private getDepositView(): void {
        this.loadingVisible = true;
        this.depositsService.getDepositDetailById(this.depositParams).subscribe(
            (responseData: DepositDetailResultDto) => {
                this.depositDetails = responseData;
                this.depositSourceItems = responseData.items;
                this.popupTitle = `Deposit # ${responseData.cmDepositId}`;
                this.bankAccount = `${responseData.bankAccountName}, ${responseData.protectedAccountNumber}, ${responseData.bankName}`;
                this.loadingVisible = false;
            },
            (error) => {
                this.serverErrorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }
}
